module.exports = __webpack_public_path__ + "img/bear.4bf5ac7b.png";